import type { Role } from './auth-store';

// Which roles can this actor create via the portal? Mirrors backend
// authz/userCreation.ts — keep in sync.
export function allowedTargetRoles(actor: { role: Role; isSuperAdmin: boolean }): Role[] {
  if (actor.isSuperAdmin) {
    return ['super_admin', 'reseller_owner', 'agent', 'office_manager', 'standard_user', 'limited_user'];
  }
  if (actor.role === 'reseller_owner') {
    return ['reseller_owner', 'agent', 'office_manager', 'standard_user', 'limited_user'];
  }
  if (actor.role === 'office_manager') {
    return ['standard_user', 'limited_user'];
  }
  return [];
}

export const ROLE_LABEL: Record<Role, string> = {
  super_admin: 'Super Admin',
  reseller_owner: 'Reseller Owner',
  agent: 'Agent',
  office_manager: 'Office Manager',
  standard_user: 'Standard User',
  limited_user: 'Limited User',
};
